import { DarkVerticalBanner } from '@dtk/ui-components';
import { TeaserBannerProps } from './types';

export const TeaserBanner = (props: TeaserBannerProps) => {
  return <DarkVerticalBanner {...props} />;
};
